import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DateHelper } from '@prikverwerker/helpers/DateHelper';
import { CreateSurveyCampaign } from '@prikverwerker/models/create-survey-campaign';
import { NewSurveyCampaign } from '@prikverwerker/models/new-survey-campaign';
import { ApiService } from '@prikverwerker/services/api.service';
import { AlertService } from '@services/alert.service';
import { take } from 'rxjs';

@Component({
  selector: 'mdk-create-survey-campaign-modal',
  templateUrl: './create-survey-campaign-modal.component.html',
})
export class CreateSurveyCampaignModalComponent {
  @Input() identifier!: string;

  @ViewChild('testStartDate')
  private testStartDate!: ElementRef;
  @ViewChild('createSurveyCampaignOpenButton')
  private createSurveyCampaignOpenButton!: ElementRef<HTMLElement>;
  @ViewChild('createSurveyCampaignCloseButton')
  private createSurveyCampaignCloseButton!: ElementRef<HTMLElement>;

  newSurveyCampaign: NewSurveyCampaign = {
    id: '',
    surveyZones: [],
    tideStations: [],
  };
  createSurveyCampaign: CreateSurveyCampaign = {
    id: '',
    startDate: '',
    zoneCode: '',
    tideStationCode: '',
  };

  constructor(
    private apiService: ApiService,
    private alertService: AlertService,
    private router: Router
  ) {}

  openModal(campaign: NewSurveyCampaign) {
    this.createSurveyCampaignOpenButton.nativeElement.click();
    this.initialize(campaign);
  }

  private closeModal(): void {
    this.createSurveyCampaignCloseButton.nativeElement.click();
  }

  onClickCreate() {
    this.apiService
      .createSurveyCampaign$(this.createSurveyCampaign)
      .pipe(
        take(1) // Automatically unsubscribe after receiving a response
      )
      .subscribe({
        next: (data) => {
          this.closeModal();
          this.router.navigate([
            'detail-survey-campaign',
            this.createSurveyCampaign.id,
          ]);
        },
        error: (error: HttpErrorResponse) => {
          this.closeModal();
          this.alertService.onAlert({
            title: 'Kan geen prikcampagne maken',
            message:
              error.status == 400
                ? error.error
                : 'Geef deze melding door als het probleem regelmatig voorkomt. ' +
                  error.message,
            type: 'error',
          });
        },
      });
  }

  private initialize(campaign: NewSurveyCampaign) {
    this.newSurveyCampaign = campaign;
    // TODO JENS implement when api is ready
    // this.newSurveyCampaign.tideStations = [{
    //     tideStationCode: 'Zeebrugge Leopold II Dam',
    //     tideStationDescription: 'Zeebrugge Leopold II Dam',
    //   }];
    this.createSurveyCampaign.id = campaign.id;
    this.createSurveyCampaign.startDate = DateHelper.GetDateAsYYMMDD();

    this.SetElementValidations();
  }

  private SetElementValidations(): void {
    let prevVal = '';

    let testElement = this.testStartDate.nativeElement;
    testElement.addEventListener('input', function (e: any) {
      if (testElement.validity.valid) {
        prevVal = testElement.value;
      } else {
        testElement.value = prevVal;
      }
    });
  }
}
